<template>
  <form
    class="form"
    method="POST"
    action="javascript:;"
    @submit.prevent="submit"
  >
    <FormError v-if="formError.length > 0" :errorMessages="formError" />

    <FormLoading v-if="!formReady" />

    <CardBase v-else>
      <template #header>{{ $route.meta.title }}</template>
      <template #content>
        <FormNote class="mb-6"
          >Note: Kolom <strong>Asset</strong>,
          <strong>From Member / ID</strong>, dan
          <strong>Transfer To</strong> tidak dapat diubah ketika form sudah
          dibuat (walaupun status masih pending). Periksa lagi dengan teliti
          sebelum submit form!</FormNote
        >
        <FormRow class="mb-4" :required="true">
          <template #label>Asset</template>
          <template #field>
            <multiselect
              v-model="formData.asset"
              :options="listAsset"
              :loading="listAssetLoading"
              :close-on-select="true"
              :hide-selected="false"
              :allow-empty="false"
              :class="$v.formData.asset.$error ? 'multiselect--error' : ''"
              :disabled="!formCreate"
              track-by="id"
              label="name"
              tag-placeholder="Press enter to choose"
              placeholder="Choose asset"
              :showLabels="false"
              @select="clearListAccount"
            >
              <template #noResult>No results found.</template>
            </multiselect>
            <div
              class="form-error"
              v-if="$v.formData.asset.$error && formSubmitted"
            >
              <span class="form-error__text" v-if="!$v.formData.asset.required"
                >This field is required.</span
              >
            </div>
          </template>
          <template #help v-if="!formCreate"
            >Create a new transfer form if you want to change asset</template
          >
        </FormRow>

        <FormRow class="mb-4" :required="true">
          <template #label>From Member / ID</template>
          <template #field>
            <div v-if="formCreate">
              <multiselect
                v-model="formData.account"
                :options="listAccount"
                :loading="listAccountLoading"
                :close-on-select="true"
                :hide-selected="false"
                :allow-empty="false"
                :class="$v.formData.account.$error ? 'multiselect--error' : ''"
                track-by="id"
                label="tooltip"
                tag-placeholder="Press enter to choose"
                placeholder="Search member"
                :showLabels="false"
                :internal-search="false"
                :disabled="!formCreate"
                :searchable="formCreate"
                @search-change="getListAccount"
                @select="getListAccountForTransfer"
              >
                <template #noOptions v-if="formData.asset"
                  >Search member in {{ formData.asset.name }}.</template
                >
                <template #noOptions v-else
                  >Please select asset first.</template
                >
                <template #noResult v-if="formData.asset"
                  >No results found.</template
                >
                <template #noResult v-else>Please select asset first.</template>
              </multiselect>
              <div
                class="form-error"
                v-if="$v.formData.account.$error && formSubmitted"
              >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.account.required"
                  >This field is required.</span
                >
              </div>
            </div>
            <div v-else>
              <input
                class="bg-gray-400 bg-opacity-25 form__input"
                readonly
                disabled
                type="text"
                :value="formData.account.tooltip"
              />
            </div>
          </template>
          <template #help>
            <span v-if="formCreate"
              >Search by ID, username or member's bank account</span
            >
            <span v-else
              >Create a new transfer form if you want to change member /
              ID</span
            >
            <button
              type="button"
              class="button button--primary mt-2"
              v-if="formData.account"
              v-clipboard:copy="formData.account.panel_id"
            >
              Copy {{ formData.account.panel_id }}
            </button>
          </template>
        </FormRow>

        <FormRow
          class="mb-4"
          :required="true"
          v-if="formData.account || $route.params.accountId"
        >
          <template #label>Transfer To:</template>
          <template #field>
            <div v-if="formCreate">
              <multiselect
                v-model="formData.to_account"
                :options="listAccountForTransfer"
                :loading="listAccountForTransferLoading"
                :close-on-select="true"
                :hide-selected="false"
                :allow-empty="false"
                :class="
                  $v.formData.to_account.$error ? 'multiselect--error' : ''
                "
                track-by="id"
                label="tooltip"
                tag-placeholder="Press enter to choose"
                placeholder="Choose ID"
                :disabled="!formCreate"
                :showLabels="false"
                :internal-search="false"
              >
                <template #noOptions v-if="formData.asset"
                  >This member has only one account ID.</template
                >
                <template #noOptions v-else
                  >Please select asset first.</template
                >
                <template #noResult v-if="formData.asset"
                  >No results found.</template
                >
                <template #noResult v-else>Please select asset first.</template>
              </multiselect>
              <div
                class="form-error"
                v-if="$v.formData.to_account.$error && formSubmitted"
              >
                <span
                  class="form-error__text"
                  v-if="!$v.formData.to_account.required"
                  >This field is required.</span
                >
              </div>
            </div>
            <div v-else>
              <input
                class="bg-gray-400 bg-opacity-25 form__input"
                readonly
                disabled
                type="text"
                :value="formData.transfer.account.tooltip"
              />
            </div>
          </template>
          <template #help>
            <span
              >Create a new transfer form if you want to change member /
              ID</span
            >
            <button
              type="button"
              class="button button--primary mt-2"
              v-if="formData.transfer"
              v-clipboard:copy="formData.transfer.account.panel_id"
            >
              Copy {{ formData.transfer.account.panel_id }}
            </button>
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="true">
          <template #label>Transfer Amount</template>
          <template #field>
            <input
              :class="{
                'form__input--error':
                  $v.formData.amount.$error && formSubmitted,
              }"
              type="text"
              class="form__input"
              placeholder="Transfer Amount"
              v-model="formData.amount"
              @blur="calculateBalance"
              v-currency="{
                currency: null,
                distractionFree: false,
                allowNegative: false,
                locale: 'en',
              }"
            />
            <div
              class="form-error"
              v-if="$v.formData.amount.$error && formSubmitted"
            >
              <span class="form-error__text" v-if="!$v.formData.amount.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <h3 class="form__section-heading" v-if="!formCreate">
          {{ formData.account.tooltip }}
        </h3>

        <FormRow class="mb-4" v-if="!formCreate">
          <template #label>Credit Balance</template>
          <template #field>
            <input
              :class="{
                'form__input--error':
                  $v.formData.from_before_credit.$error && formSubmitted,
                'bg-gray-400 bg-opacity-25': currentStatus != 0,
              }"
              type="text"
              class="form__input"
              placeholder="Current Credit Balance"
              v-model="formData.from_before_credit"
              @blur="calculateBalance"
              :disabled="currentStatus != 0"
              :readonly="currentStatus != 0"
              v-currency="{
                currency: null,
                distractionFree: false,
                locale: 'en',
              }"
            />
            <div
              class="form-error"
              v-if="$v.formData.from_before_credit.$error && formSubmitted"
            >
              <span
                class="form-error__text"
                v-if="!$v.formData.from_before_credit.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormRow class="mb-4" v-if="!formCreate">
          <template #label>New Credit Balance </template>
          <template #field>
            <input
              readonly
              disabled
              type="text"
              class="form__input bg-gray-400 bg-opacity-25"
              placeholder="New Credit Balance"
              v-model="newCreditBalance"
            />
            <button
              type="button"
              class="button button--primary mt-2"
              v-clipboard:copy="
                Math.floor(parseFloat(parseCurrency(newCreditBalance) / 1000))
              "
            >
              Copy
              {{
                Math.floor(parseFloat(parseCurrency(newCreditBalance) / 1000))
              }}
            </button>
          </template>
        </FormRow>

        <h3 class="form__section-heading" v-if="!formCreate">
          {{ formData.transfer.account.tooltip }}
        </h3>

        <FormRow class="mb-4" v-if="!formCreate">
          <template #label>Credit Balance</template>
          <template #field>
            <input
              :class="{
                'form__input--error':
                  $v.formData.from_before_credit.$error && formSubmitted,
                'bg-gray-400 bg-opacity-25': currentStatus != 0,
              }"
              type="text"
              class="form__input"
              placeholder="Current Credit Balance"
              v-model="formData.to_before_credit"
              @blur="calculateBalance"
              :disabled="currentStatus != 0"
              :readonly="currentStatus != 0"
              v-currency="{
                currency: null,
                distractionFree: false,
                locale: 'en',
              }"
            />
            <div
              class="form-error"
              v-if="$v.formData.to_before_credit.$error && formSubmitted"
            >
              <span
                class="form-error__text"
                v-if="!$v.formData.to_before_credit.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormRow class="mb-4" v-if="!formCreate">
          <template #label>New Credit Balance</template>
          <template #field>
            <input
              readonly
              disabled
              type="text"
              class="form__input bg-gray-400 bg-opacity-25"
              placeholder="New Credit Balance"
              v-model="newCreditBalanceToAccount"
            />
            <button
              type="button"
              class="button button--primary mt-2"
              v-clipboard:copy="
                Math.floor(
                  parseFloat(parseCurrency(newCreditBalanceToAccount) / 1000)
                )
              "
            >
              Copy
              {{
                Math.floor(
                  parseFloat(parseCurrency(newCreditBalanceToAccount) / 1000)
                )
              }}
            </button>
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="true">
          <template #label>Panel Date</template>
          <template #field>
            <date-picker
              v-model="formData.date"
              type="datetime"
              :editable="false"
              :clearable="false"
              :show-seconds="false"
              input-class="form__input"
              value-type="YYYY-MM-DD HH:mm:ss"
              format="DD MMMM YYYY - HH:mm"
              time-title-format="DD MMM YYYY"
              placeholder="Panel Date / Time"
              :disabled-date="notAfterToday"
              :disabled-time="notAfterNow"
            ></date-picker>
            <div
              class="form-error"
              v-if="$v.formData.date.$error && formSubmitted"
            >
              <span class="form-error__text" v-if="!$v.formData.date.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormRow class="mb-4">
          <template #label>Note</template>
          <template #field>
            <textarea
              class="form__input"
              placeholder="Note"
              rows="5"
              v-model="formData.note"
            ></textarea>
          </template>
        </FormRow>

        <FormRow class="mb-4" :required="!formCreate && currentStatus == 0">
          <template #label>Status</template>
          <template #field>
            <div class="flex">
              <button
                v-if="formCreate"
                class="
                  border-gray-600
                  button
                  border border-solid
                  hover:bg-gray-600
                  hover:text-white
                  transition-all
                  duration-200
                  mr-2
                  text-left
                "
                :class="
                  !formData.status || formData.status == '0'
                    ? 'bg-gray-600 text-white'
                    : 'text-gray-600'
                "
                type="button"
                @click="setStatus(0)"
              >
                <span class="text-xs"
                  ><font-awesome-icon :icon="['fas', 'question-circle']" />
                  Pending</span
                >
              </button>
              <button
                v-if="currentStatus != 2 && userCan('update.transfer')"
                class="
                  border-green-500
                  button
                  border border-solid
                  hover:bg-green-500
                  hover:text-white
                  transition-all
                  duration-200
                  mr-2
                  text-left
                "
                :class="
                  formData.status == '1'
                    ? 'bg-green-500 text-white'
                    : 'text-green-500'
                "
                @click="setStatus(1)"
                type="button"
              >
                <span class="text-xs"
                  ><font-awesome-icon :icon="['fas', 'check-circle']" />
                  Approve</span
                >
              </button>
              <button
                v-if="!formCreate && userCan('delete.transfer')"
                class="
                  border-red-500
                  button
                  border border-solid
                  hover:bg-red-500
                  hover:text-white
                  transition-all
                  duration-200
                  text-left
                "
                :class="
                  formData.status == '2'
                    ? 'bg-red-500 text-white'
                    : 'text-red-500'
                "
                @click="setStatus(2)"
                type="button"
              >
                <span class="text-xs"
                  ><font-awesome-icon :icon="['fas', 'times-circle']" />
                  Reject</span
                >
              </button>
            </div>
            <div
              class="form-error"
              v-if="$v.formData.status.$error && formSubmitted"
            >
              <span class="form-error__text" v-if="!$v.formData.status.required"
                >This field is required.</span
              >
            </div>
          </template>
        </FormRow>

        <FormDataLog :data="formData" v-if="!formCreate" />
      </template>

      <template #footer>
        <FormNote class="mb-6"
          >Note: Kolom <strong>Asset</strong>,
          <strong>From Member / ID</strong>, dan
          <strong>Transfer To</strong> tidak dapat diubah ketika form sudah
          dibuat (walaupun status masih pending). Periksa lagi dengan teliti
          sebelum submit form!</FormNote
        >
        <FormRow class="mb-0">
          <template
            #field
            v-if="
              currentStatus != 2 &&
              (userCan('create.transfer') ||
                userCan('update.transfer') ||
                userCan('delete.transfer'))
            "
          >
            <BaseButton class="mr-2" type="submit">Submit</BaseButton>
          </template>
          <template #link>
            <div>
              <template v-if="currentStatus != 2">or</template>
              <router-link
                :to="{ name: 'TransferList' }"
                class="link"
                :class="{
                  'ml-2': currentStatus != 2,
                }"
                >Back to List Transfer</router-link
              >
            </div>
          </template>
        </FormRow>
      </template>
    </CardBase>

    <!-- <CardBase v-if="!formCreate && formReady" class="mt-10">
      <template #header>Changelog</template>
      <template #content>
        <table class="w-full table-fixed">
          <thead v-if="!listLogsLoading">
            <tr>
              <th class="w-2/12">Date / Time</th>
              <th class="w-2/12">User</th>
              <th class="w-2/12">Action</th>
              <th class="text-left">Changes</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="table__loader" colspan="4" v-if="listLogsLoading">
                Please wait
                <font-awesome-icon
                  :icon="['fas', 'spinner']"
                  spin
                  class="ml-2"
                />
              </td>
            </tr>
            <tr v-if="listLogs.length <= 0 && !listLogsLoading">
              <td class="text-center pt-6" colspan="4">No data found.</td>
            </tr>
            <tr v-for="row in listLogs" :key="row.id">
              <td>{{ row.created_at }}</td>
              <td>{{ row.created_by.name }}</td>
              <td>{{ row.action }}</td>
              <td>
                <pre
                  v-if="row.changes"
                  class="text-left"
                  v-html="printJson(row.changes)"
                ></pre>
              </td>
            </tr>
          </tbody>
        </table>
      </template>
    </CardBase> -->
  </form>
</template>

<script>
import { required, requiredIf } from "vuelidate/lib/validators";
import { CurrencyDirective, parse } from "vue-currency-input";
import { getListAssetMixin } from "@/mixins/getListAssetMixin";
import { submitFormMixin } from "@/mixins/submitFormMixin";
import { datePickerMixin } from "@/mixins/datePickerMixin";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
// import CoolLightBox from "vue-cool-lightbox";
// import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";

const prettyPrintJson = require("pretty-print-json");

export default {
  directives: {
    currency: CurrencyDirective,
  },
  mixins: [
    getListAssetMixin,
    submitFormMixin,
    datePickerMixin,
  ],
  components: {
    Multiselect,
    DatePicker,
    // CoolLightBox,
  },
  data: () => {
    return {
      listAsset: [],
      listAssetLoading: false,
      listAccount: [],
      listAccountLoading: false,
      listAccountForTransfer: [],
      listAccountForTransferLoading: false,

      listLogs: [],
      listLogsLoading: true,

      formData: {
        asset: null,
        note: null,
        account: null,
        amount: null,
        from_before_credit: null,
        to_before_credit: null,
        status: null,
        date: "",
      },

      newCreditBalance: 0,
      newCreditBalanceToAccount: 0,

      currentStatus: "",
    };
  },
  validations: {
    formData: {
      asset: {
        required,
      },
      account: {
        required,
      },
      to_account: {
        required,
      },
      amount: {
        required,
      },
      date: {
        required,
      },
      from_before_credit: {
        required: requiredIf(function () {
          return !this.formCreate;
        }),
      },
      to_before_credit: {
        required: requiredIf(function () {
          return !this.formCreate;
        }),
      },
      status: {
        required,
      },
    },
  },
  watch: {
    $route(to) {
      if (to.name == "TransferCreate") {
        this.formCreate = true;
        this.formData = {
          asset: null,
          note: null,
          account: null,
          amount: null,
          from_before_credit: null,
          to_before_credit: null,
          status: null,
          date: this.dateformat(new Date()),
        };
      } else if (to.name == "TransferEdit") {
        this.formData.id = this.$route.params.id;
        this.formCreate = false;
        this.fetchData();
      }
    },
  },
  computed: {
    submitUrl() {
      return this.formCreate
        ? "/" + this.$route.meta.endpoint
        : "/" + this.$route.meta.endpoint + "/" + this.formData.id;
    },
    fetchEndPoint() {
      return this.$route.meta.endpoint;
    },
    isFormCreate() {
      return this.formCreate;
    },
  },
  created() {
    if (this.formCreate) {
      this.getListAsset();
      this.listAssetLoading = true;
    }

    this.$_debounceTimer = null;

    this.formData.date = this.dateformat(new Date());

    if (this.formCreate) {
      this.formData.status = 0;

      if (this.$route.params.accountId) {
        this.listAccountLoading = true;
        this.$http
          .get(
            process.env.VUE_APP_API_URL +
              "/member-account?uuid=" +
              this.$route.params.accountId
          )
          .then((res) => {
            if (res.status == 200) {
              const response = res.data;

              if (response.data) {
                this.listAccount = response.data;

                this.formData.account = response.data[0];
                this.formData.asset = response.data[0].asset;
                this.getListAccountForTransfer();
                this.setStatus(1);
              }
            }
          })
          .finally(() => {
            this.listAccountLoading = false;
          });
      }

      // this.setFromMemberAccount();

      // this.listAccountForTransferLoading = true;
      // this.$http
      //   .get(
      //     process.env.VUE_APP_API_URL +
      //       "/member/" +
      //       this.formData.account.member.uuid +
      //       "/account/" +
      //       this.formData.account.uuid +
      //       "/exclude"
      //   )
      //   .then((res) => {
      //     if (res.status == 200) {
      //       const response = res.data;

      //       if (response) {
      //         this.listAccountForTransfer = response.data;
      //       }
      //     }
      //   })
      //   .finally(() => {
      //     this.listAccountForTransferLoading = false;
      //   });
    }
  },
  methods: {
    parseCurrency(data) {
      return parse(data);
    },
    calculateBalance() {
      if (!this.formData.amount) this.formData.amount = 0;
      if (!this.formData.from_before_credit)
        this.formData.from_before_credit = 0;
      if (!this.formData.to_before_credit) this.formData.to_before_credit = 0;

      const amount = parse(this.formData.amount);
      const before_credit = parse(this.formData.from_before_credit);
      const before_credit_to_account = parse(this.formData.to_before_credit);

      if (
        isNaN(amount) ||
        isNaN(before_credit) ||
        isNaN(before_credit_to_account)
      ) {
        this.newCreditBalance = "Error";
        this.newCreditBalanceToAccount = "Error";
      } else {
        this.newCreditBalance = Intl.NumberFormat("en", {
          minimumFractionDigits: 2,
        }).format(before_credit - amount);

        this.newCreditBalanceToAccount = Intl.NumberFormat("en", {
          minimumFractionDigits: 2,
        }).format(before_credit_to_account + amount);
      }
    },
    getListAccountForTransfer() {
      this.debounce(() => {
        this.listAccountForTransferLoading = true;
        (this.listAccountForTransfer = []), delete this.formData.to_account;
        this.$http
          .get(
            process.env.VUE_APP_API_URL +
              "/member/" +
              this.formData.account.member.uuid +
              "/account/" +
              this.formData.account.uuid +
              "/exclude"
          )
          .then((res) => {
            if (res.status == 200) {
              const response = res.data;

              if (response) {
                this.listAccountForTransfer = response.data;
              }
            }
          })
          .finally(() => {
            this.listAccountForTransferLoading = false;
          });
      }, 250);
    },
    printJson(data) {
      return data ? prettyPrintJson.toHtml(JSON.parse(data)) : "-";
    },
    getListLogs() {
      this.$http
        .get(
          process.env.VUE_APP_API_URL + this.$route.path.replace("edit", "log")
        )
        .then((res) => {
          if (res.status == 200) {
            this.listLogsLoading = false;

            const response = res.data;

            if (response) {
              this.listLogs = response;
            }
          }
        })
        .finally(() => {});
    },
    setStatus(status) {
      this.formData.status = status;
    },
    dateformat(date, format = "YYYY-MM-DD HH:mm:ss") {
      return this.moment(date).format(format);
    },
    clearListAccount() {
      this.listAccount = [];
      this.listAccountForTransfer = [];
      delete this.formData.account;
      delete this.formData.to_account;
    },
    clearListAccountForTransfer() {
      this.listAccountForTransfer = [];
      delete this.formData.to_account;
    },
    fetchData(id) {
      this.formReady = false;

      const itemId = id ? id : this.formData.id;

      this.$http
        .get(
          process.env.VUE_APP_API_URL + "/" + this.fetchEndPoint + "/" + itemId
        )
        .then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            this.formData = { ...this.formData, ...data };

            this.formData.to_account = data.transfer.account;
            this.formData.from_before_credit = data.before_credit;
            this.formData.to_before_credit = data.transfer.before_credit;
            // this.formData.status = data.status;

            if (data.status == 0) {
              this.formData.status = null;
              this.formData.from_before_credit = data.account.balance.amount;
              this.formData.to_before_credit =
                data.transfer.account.balance.amount;
            }

            this.formData.note = data.note;
            this.formData.date = data.date;

            this.currentStatus = data.status;

            this.calculateBalance();

            this.formReady = true;
          }
        })
        .catch((err) => {
          // console.log(err);
          if (err.response.status == 404) {
            this.$router.push({ name: this.$route.meta.baseRoute });
          } else if (err.response.status == 500) {
            this.formError = [];
            this.formError[0] = err.response.data.message;
          }
        })
        .finally(() => {});
    },
    getListAccount(query) {
      if (this.formData.asset && query.length >= 3) {
        this.debounce(() => {
          this.listAccountLoading = true;
          this.$http
            .get(
              process.env.VUE_APP_API_URL +
                "/member-account?asset_id=" +
                this.formData.asset.id +
                "&search=" +
                query
            )
            .then((res) => {
              if (res.status == 200) {
                const response = res.data;

                if (response) {
                  this.listAccount = response.data;
                }
              }
            })
            .finally(() => {
              this.listAccountLoading = false;
            });
        }, 500);
      }
    },
    debounce(method, timer) {
      if (this.$_debounceTimer !== null) {
        clearTimeout(this.$_debounceTimer);
      }
      this.$_debounceTimer = setTimeout(() => {
        method();
      }, timer);
    },
  },
};
</script>
